import { type Meta } from '../types/docs';
import {
  AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
  AUTOMATIONS_ANALYTICS_PROMPT_MODES,
  AUTOMATIONS_ANALYTICS_SCHEDULE_REPEATS,
} from './automationsAnalytics';

const META: Meta = {
  description: 'The user saves changes to an automation',
  name: 'automation_saved',
  params: [
    AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The automation that was saved',
      name: 'automation_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Whether the automation uses a linked skill or a custom prompt',
      name: 'prompt_mode',
      required: true,
      type: 'enum',
      values: [...AUTOMATIONS_ANALYTICS_PROMPT_MODES],
    },
    {
      description: 'Schedule repeat interval when a recurring schedule is set',
      name: 'schedule_repeat',
      required: false,
      type: 'enum',
      values: [...AUTOMATIONS_ANALYTICS_SCHEDULE_REPEATS],
    },
  ],
};

export default META;
